var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompletedcheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 15,
    width: 43.5,
    height: 32.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0395508 32.0395C0.0395508 14.3956 14.3956 0.0395508 32.0395 0.0395508C49.6849 0.0395508 64.0395 14.3956 64.0395 32.0395C64.0395 49.6835 49.6835 64.0395 32.0395 64.0395C14.3956 64.0395 0.0395508 49.6835 0.0395508 32.0395ZM48.8869 26.2762C49.937 25.3797 50.0615 23.8017 49.1649 22.7516C48.2684 21.7016 46.6904 21.5771 45.6404 22.4736L26.3909 38.9083L21.0208 34.0278C19.999 33.0992 18.4179 33.1747 17.4893 34.1965C16.5607 35.2183 16.6362 36.7994 17.658 37.728L24.6579 44.0896C25.5895 44.9363 27.0052 44.9582 27.9626 44.1408L48.8869 26.2762Z",
    fill: "#248647"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedcheckmark);
export default __webpack_public_path__ + "static/media/completedcheckmark.3f5aff517683654017f82d398cb0cde1.svg";
export { ForwardRef as ReactComponent };